

import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'
import { useAppStore } from '../store/appStore.tsx';

const Loading = () => {
    const { showLoading } = useAppStore(appStore => appStore);

    return (
        <Backdrop
            open={showLoading}
            sx={{zIndex: (theme) => theme.zIndex.modal + 1}}  
        >
            <CircularProgress sx={{ color: 'white' }} />
        </Backdrop>
    )
}

export default Loading